/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Box } from "@mui/material";
import * as Actions from "actions";
import TryIcon from '@mui/icons-material/Try';

// Import Swiper styles
import 'swiper/swiper.min.css';
//import 'swiper/components/navigation/navigation.min.css';
import './UserProductRecommendedViewedSlider.scss';

// import Custom Components
import UserProductItem from "components/elements/user/products/UserProductItem";
import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import {isFeatureSupported} from "helpers/utils";

const UserProductRecommendedSlider = (props) => {
  const {
    products, currency, addProductToCart, addProductToWishlist,
    addToCompare, userMainGetRecommendedProductsViewed, isLoading, marketId
  } = props;

  useEffect(() => {
      userMainGetRecommendedProductsViewed("", "", "", marketId);
  }, []);

    const breakpoints = {
        300: {
            slidesPerView: 2.0,
            spaceBetween: 20,
        },
        340: {
            slidesPerView: 2.2,
            spaceBetween: 20,
        },
        380: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 2.8,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    const renderResults = () => (

    <Container>
        {<CustomSectionCreator icon={<TryIcon sx={{ color: '#E53E3E', mr: 1 }} />} title='You May Like' seeLink="/products/recommend/viewed" seeMoreLinkTitle={isFeatureSupported("shopreels") ? "View more" : "View more"} seeMoreLink={isFeatureSupported("shopreels") ? "/products/recommend/viewed?ls=1" : "/products/recommend/viewed"}   />}
        <swiper-container slides-per-view="1.8" space-between="4" free-mode="true" breakpoints={JSON.stringify(breakpoints)}>
            { products.map((product, index) => (
                <swiper-slide key={index}>
                    <Box sx={{ width: 150 }}>
                        <UserProductItem
                            product={product}
                            isDirect={true}
                            linkArrow={isFeatureSupported("shopreels") ? "/products/recommend/viewed?ls=1&li=" + index : ""}
                            linkMain={"/products/recommend/viewed?ls=2&li=" + index}
                            //link={isFeatureSupported("shopreels") ? "/products/recommend/viewed?ls=1&li=" + index : ""}
                            currency={currency}
                            onAddToCompareClicked={() => addToCompare(product)}
                            onAddToWishlistClicked={() => addProductToWishlist(product)}
                            onAddToCartClicked={() => addProductToCart(product, "")}
                        />
                    </Box>
                </swiper-slide>
            ))}
        </swiper-container>
    </Container>
    );

  return (

      <>
          {isLoading ? <MockProductBox />
              : products.length > 0
                  ? renderResults()
                  : ""}

      </>


  );
};

UserProductRecommendedSlider.defaultProps = {
  symbol: "$",
};

UserProductRecommendedSlider.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  addProductToWishlist: PropTypes.func.isRequired,
  addToCompare: PropTypes.func.isRequired,
    userMainGetRecommendedProductsViewed: PropTypes.func.isRequired,
};

// Mapping Props and State.
const UserProductRecommendedSliderComponent = connect(
  ({ userMainProducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainProducts.reqStatus,
    isLoading: userMainProducts.isLoading,
    serviceError: userMainProducts.serviceError,
    products: userMainProducts.recommendedproductsviewed,
    currency: bootupInfo.symbol,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserProductRecommendedSlider);

export default UserProductRecommendedSliderComponent;
